import LoginPage from "./LoginPage";
import HomePage from "./HomePage";
import ApplicationDetailPage from "./ApplicationDetailPage";
import ApplicationsListPage from "./ApplicationsListPage";
import CustomerDetailPage from "./CustomerDetailPage";
import CustomersListPage from "./CustomersListPage";
import LicenseDetailPage from "./LicenseDetailPage";
import LicensesInUseListPage from "./LicensesInUseListPage";
import LicensesListPage from "./LicensesListPage";
import UsersListPage from "./UsersListPage";
import UserDetailPage from "./UserDetailPage";
import LogsPage from "./LogsPage";
import OfflineLicensesInUseListPage from "./OfflineLicensesInUseListPage";
import OfflineLicensesInUseDetailPage from "./OfflineLicensesInUseDetailPage";

export default {
  LoginPage: LoginPage,
  HomePage: HomePage,
  ApplicationDetailPage: ApplicationDetailPage,
  ApplicationsListPage: ApplicationsListPage,
  CustomerDetailPage: CustomerDetailPage,
  CustomersListPage: CustomersListPage,
  LicenseDetailPage: LicenseDetailPage,
  LicensesInUseListPage: LicensesInUseListPage,
  LicensesListPage: LicensesListPage,
  UsersListPage: UsersListPage,
  UserDetailPage: UserDetailPage,
  LogsPage: LogsPage,
  OfflineLicensesInUseListPage: OfflineLicensesInUseListPage,
  OfflineLicensesInUseDetailPage: OfflineLicensesInUseDetailPage
};



// WEBPACK FOOTER //
// ./src/Pages/index.js